import classNames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { useMemo } from 'react';

import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import { markdownToHtml } from 'utils/markdown';

import { localizeMessageTimestamps } from '../../../../../../utils/localizeTimestamps';

import styles from './sidekickMessage.module.scss';

type SidekickMessageProps = {
  role: 'user' | 'assistant' | 'system';
  text: string;
} & PropsWithClassName;

export const SidekickMessage = ({
  role,
  text,
  className,
}: SidekickMessageProps): JSX.Element => {
  const isUser = role === 'user';
  const html = useMemo(
    () => markdownToHtml(localizeMessageTimestamps(text)),
    [text],
  );
  return (
    <SafeInnerHtmlSetter
      element="div"
      className={classNames(
        styles.bubble,
        {
          [styles.bubbleUser]: isUser,
          [styles.bubbleAssistant]: !isUser,
        },
        className,
      )}
      content={html}
      profile="sidekick"
    />
  );
};
